/**
 * Wrapping focus cursor for menu lists — the pattern every scene previously
 * hand-rolled (`focus = (focus + nav + n) % n`). Used by the wizard scenes
 * (Character/Relic/Forge); older overlays keep their local copies untouched.
 */
export class FocusList {
  focus = 0;

  constructor(private count: number) {}

  setCount(n: number): void {
    this.count = n;
    if (this.focus >= n) this.focus = Math.max(0, n - 1);
  }

  /** Move by delta with wraparound; returns true if the focus changed. */
  move(delta: number): boolean {
    if (delta === 0 || this.count <= 1) return false;
    this.focus = (this.focus + delta + this.count) % this.count;
    return true;
  }
}
